/**
 * W66.W6 — Checkpoint snapshot: 10-row table CP1-CP10.
 * Static from plan_data.cp_snapshot (not live cp_score_breakdown).
 * Status pills: TBD-PASS / TBD / Partial / PASS / FAIL
 * Canon CP names must be used exactly.
 */

import React from "react";

interface CpRow {
  cp: number;
  name: string;
  status: string;
  note: string;
}

interface CpSnapshotProps {
  planData: Record<string, any>;
}

// Status pill style mapping
const STATUS_STYLES: Record<string, { bg: string; color: string }> = {
  "TBD-PASS": { bg: "#EFF6FF", color: "#0B0B0F" },
  TBD: { bg: "#F3F4F6", color: "#6B7280" },
  Partial: { bg: "#FFF7ED", color: "#EA580C" },
  PASS: { bg: "#F0FDF4", color: "#16A34A" },
  FAIL: { bg: "#FEF2F2", color: "#DC2626" },
};

function StatusPill({ status }: { status: string }) {
  const s = STATUS_STYLES[status] ?? STATUS_STYLES.TBD;
  return (
    <span
      style={{
        background: s.bg,
        color: s.color,
        borderRadius: 4,
        padding: "2px 8px",
        fontSize: 11,
        fontWeight: 700,
        whiteSpace: "nowrap",
      }}
    >
      {status}
    </span>
  );
}

export default function CpSnapshot({ planData }: CpSnapshotProps) {
  const cpSnapshot: CpRow[] = planData.cp_snapshot ?? [];

  if (cpSnapshot.length === 0) return null;

  return (
    <section style={{ marginBottom: 28 }}>
      <h2
        style={{
          fontSize: 12,
          fontWeight: 700,
          color: "#374151",
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          margin: "0 0 10px",
          borderBottom: "1px solid #E5E7EB",
          paddingBottom: 6,
        }}
      >
        Checkpoint Snapshot
      </h2>

      <table
        style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}
      >
        <thead>
          <tr style={{ background: "#F9FAFB" }}>
            <th
              style={{
                padding: "8px 12px",
                textAlign: "left",
                fontSize: 11,
                fontWeight: 700,
                color: "#6B7280",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                borderBottom: "1px solid #E5E7EB",
                width: 40,
              }}
            >
              CP
            </th>
            <th
              style={{
                padding: "8px 12px",
                textAlign: "left",
                fontSize: 11,
                fontWeight: 700,
                color: "#6B7280",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                borderBottom: "1px solid #E5E7EB",
                width: 200,
              }}
            >
              Checkpoint
            </th>
            <th
              style={{
                padding: "8px 12px",
                textAlign: "left",
                fontSize: 11,
                fontWeight: 700,
                color: "#6B7280",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                borderBottom: "1px solid #E5E7EB",
                width: 120,
              }}
            >
              Status
            </th>
            <th
              style={{
                padding: "8px 12px",
                textAlign: "left",
                fontSize: 11,
                fontWeight: 700,
                color: "#6B7280",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                borderBottom: "1px solid #E5E7EB",
              }}
            >
              Note
            </th>
          </tr>
        </thead>
        <tbody>
          {cpSnapshot.map((row, i) => (
            <tr
              key={row.cp}
              style={{ background: i % 2 === 0 ? "#FFFFFF" : "#F9FAFB" }}
            >
              <td
                style={{
                  padding: "8px 12px",
                  fontWeight: 700,
                  color: "#111827",
                  borderBottom: "1px solid #E5E7EB",
                  verticalAlign: "top",
                }}
              >
                {row.cp}
              </td>
              <td
                style={{
                  padding: "8px 12px",
                  fontWeight: 600,
                  color: "#374151",
                  borderBottom: "1px solid #E5E7EB",
                  verticalAlign: "top",
                }}
              >
                CP{row.cp} \u2014 {row.name}
              </td>
              <td
                style={{
                  padding: "8px 12px",
                  borderBottom: "1px solid #E5E7EB",
                  verticalAlign: "top",
                }}
              >
                <StatusPill status={row.status} />
              </td>
              <td
                style={{
                  padding: "8px 12px",
                  color: "#374151",
                  lineHeight: 1.5,
                  borderBottom: "1px solid #E5E7EB",
                  verticalAlign: "top",
                }}
              >
                {row.note}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
